import React from 'react';
import { Switch, Router } from 'react-router-dom';                       // Need this for the pages routing
import { About } from './components/pages/About';                               // About component
import { Home } from './components/pages/Authentication/Home';                                 // Home component
import { Contact } from './components/pages/Contact';                           // Contact component
import { NoMatch } from './components/pages/NoMatch';                           // NoMatch component
import { Register } from './components/pages/Authentication/Register';                         // Register component
import { OrthopedicMenu } from './components/pages/OrthopedicWard/OrthopedicMenu';            // OrthopedicMenu component
import { PreOpMenu } from './components/pages/PreOperatingWard/PreOpMenu';                       // PreoperationMenu component
import { OpMngmtMenu } from './components/pages/OpManagmentWard/OpMngmtMenu';                   // Operating Rooms Managemtn component
import { Calendar } from './components/pages/PreOperatingWard/Calendar';
import { Patients } from './components/pages/PreOperatingWard/Candidates';
import { Footer } from './components/layout/Footer';
import { OpMngmtCalendar } from './components/pages/OpManagmentWard/OpMngmtCalendar';
import { OrthopedicStaff } from './components/pages/OrthopedicWard/OrthopedicStaff';
import { SurgicalWardMenu } from './components/pages/SurgicalWard/SurgicalWardMenu';
import { SurgicalWardMenuPriority } from './components/pages/SurgicalWard/SurgicalWardMenuPriority';
import { PriorityPage } from './components/pages/SurgicalWard/PriorityPage';
import { DomainOfRooms } from './components/pages/SurgicalWard/DomainOfRooms';
import { AddSurgeryRequest } from './components/pages/SurgicalWard/AddSurgeryRequest';
import { PatientsPreOPOrth } from './components/pages/PreOperationOrthopedic/PatientsPreOPOrth';
import { CalendarSurgical } from './components/pages/SurgicalWard/CalendarSurgical';
import { CalendarOrthopedic } from './components/pages/OrthopedicWard/CalendarOrthopedic';
import { AllocatedRooms } from './components/pages/SurgicalWard/AllocatedRooms';
import { SurgicalShifts } from './components/pages/SurgicalWard/SurgicalShifts';
import { SurgeriesRequests } from './components/pages/SurgicalWard/SurgeriesRequests';
import { SurgeriesRequestsOrthopedic } from './components/pages/OrthopedicWard/SurgeriesRequestsOrthopedic';
import { ForgotPassword } from './components/pages/Authentication/ForgotPassword';
import { OrthopedicShifts } from './components/pages/OrthopedicWard/OrthopedicShifts';
import PublicRoute from './routers/PublicRouter';
import PrivateRoute from './routers/PrivateRouter';
import history from './history';

import 'bootstrap/dist/css/bootstrap.min.css';


const App = () => {

  return (
    <Router history={history}>
      <div>
        <Switch>
          <PublicRoute path="/" component={Home} exact={true} />
          <PublicRoute path="/register" component={Register} />
          <PublicRoute path="/forgot_password" component={ForgotPassword} />
          <PrivateRoute path="/about" component={About} />
          <PrivateRoute exact path="/contact" component={Contact} />
          <PrivateRoute exact path="/forgot_password" component={ForgotPassword} />
          <PrivateRoute exact path="/pre_operation" component={PreOpMenu} />
          <PrivateRoute exact path="/pre_operation/patients" component={Patients} />
          <PrivateRoute exact path="/opmenu" component={OpMngmtMenu} />
          <PrivateRoute exact path="/calendar" component={Calendar} />
          <PrivateRoute exact path="/opmngmtcalendar" component={OpMngmtCalendar} />
          <PrivateRoute exact path="/Opmngmt" component={OpMngmtMenu} />
          <PrivateRoute exact path="/orthopedic" component={OrthopedicMenu} />
          <PrivateRoute exact path="/orthopedic/staff" component={OrthopedicStaff} />
          <PrivateRoute exact path="/orthopedic/calendar" component={CalendarOrthopedic} />
          <PrivateRoute exact path="/orthopedic/surgeries_requests" component={SurgeriesRequestsOrthopedic} />
          <PrivateRoute exact path="/orthopedic/add_surgery_request" component={AddSurgeryRequest} />
          <PrivateRoute exact path="/orthopedic/shifts" component={OrthopedicShifts} />
          <PrivateRoute exact path="/surgical" component={SurgicalWardMenu} />
          <PrivateRoute exact path="/surgical/calendar" component={CalendarSurgical} />
          <PrivateRoute exact path="/surgical/priority" component={SurgicalWardMenuPriority} />
          <PrivateRoute exact path="/surgical/priority/prioritypage" component={PriorityPage} />
          <PrivateRoute exact path="/surgical/priority/domainofrooms" component={DomainOfRooms} />
          <PrivateRoute exact path="/surgical/add_surgery_request" component={AddSurgeryRequest} />
          <PrivateRoute exact path="/surgical/allocated_rooms" component={AllocatedRooms} />
          <PrivateRoute exact path="/surgical/shifts" component={SurgicalShifts} />
          <PrivateRoute exact path="/surgical/surgeries_requests" component={SurgeriesRequests} />
          <PrivateRoute exact path="/preoporthopedic/patients" component={PatientsPreOPOrth} />
          <PrivateRoute component={NoMatch} />
        </Switch>
        <Footer/>
      </div>
    </Router>
  );

}

export default App;

